/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import {
    GET_TICKET_PDF_ERROR,
    GET_TICKET_PDF_REQUEST,
    GET_TICKET_PDF_SUCCESS,
} from 'ui-account/src/constants';
import * as types from '../constants';

const INITIALSTATE = {
    checkout: {},
    confirmation: {},
    printing: {
        loading: false,
    },
};

export default function checkout(state = INITIALSTATE, action) {
    const st = cloneDeep(state);

    switch (action.type) {
        case types.GET_CHECKOUT:
            st.checkout = action.payload;
            delete st.err;
            return st;

        case types.UPDATE_CHECKOUT_PAYMENT_TYPE:
            st.checkout.payment_type = action.payload.payment_type;
            st.checkout.saved_card_on_purchase = action.payload.saved_card_on_purchase;
            delete st.err;
            return st;

        case types.FINALIZE_CHECKOUT:
            const confirmation = {
                orderID: action.payload.order.order_id,
                orderTime: action.payload.order.order_date,
                completedReservations: action.payload.order.reservations,
                subtotal: action.payload.order.subtotal,
                discount: action.payload.order.discount,
                tax: action.payload.order.tax,
                total: action.payload.order.total,
                transactions: action.payload.order.transactions,
                modification: action.payload.modification,
            };
            st.confirmation = confirmation;
            delete st.err;
            return st;

        case types.FINALIZE_NOFEE:
            let mod = false;
            if (action.payload.modification) {
                mod = true;
            }
            const noFeeconfirmation = {
                orderID: action.payload.order_id,
                orderTime: action.payload.order_date,
                completedReservations: action.payload.reservations,
                subtotal: action.payload.subtotal,
                discount: action.payload.discount,
                tax: action.payload.tax,
                total: action.payload.total,
                modification: mod,
            };
            st.confirmation = noFeeconfirmation;
            delete st.err;
            return st;

        case types.FINALIZE_CHECKOUT_ERROR:
            st.err = types.FINALIZE_CHECKOUT_ERROR;
            return st;

        case types.FETCH_CHECKOUT_ERROR:
            const error = get(action, 'payload.response.data.error');
            if (error && error.includes('already paid')) {
                st.err = types.INITIATE_ALREADY_PAID;
            } else if (error && error.includes('rate limit exceeded')) {
                st.err = types.RATE_LIMIT_EXCEEDED;
            } else {
                st.err = types.FINALIZE_CHECKOUT_ERROR;
            }
            return st;

        case GET_TICKET_PDF_REQUEST:
            st.printing.loading = true;
            return st;
        case GET_TICKET_PDF_SUCCESS:
            st.printing.loading = false;
            return st;
        case GET_TICKET_PDF_ERROR:
            st.printing.loading = false;
            st.printing.printTicketError = action.payload;
            return st;

        default:
            return st;
    }
}
